import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img src="/images/logo.png" alt="Defy Games" />
    </div>
  );
};

export default Logo;
